module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/cenicilla_fresa/preventiva/vacciplant.png
// module id = 1552
// module chunks = 3